import { Resource as e, API as r } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Returns a list of crawling modules for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve crawling modules.
   * @returns {Promise<CrawlingModuleEntity[]>} List of crawling modules for the specified project.
   */
  listCrawlingModulesByProject(s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projectid`, {
        projectId: s
      })
    );
  }
  /**
   * Returns the download link for the Maestro setup executable.
   *
   * @returns {Promise<URL | undefined>} The download link for the Maestro setup executable, or undefined if the link is invalid.
   */
  async getMaestroDownloadLink() {
    const s = await this.api.get(
      this.buildPath(`${t.baseUrl}/download`)
    );
    try {
      return new URL(`${s}/Maestro-setup.exe`);
    } catch {
      return;
    }
  }
};
t.baseUrl = `/rest/organizations/${r.orgPlaceholder}/crawlingmodule`;
let a = t;
export {
  a as CrawlingModuleInternalResource
};
//# sourceMappingURL=CrawlingModuleInternalResource.js.map
